import { render, staticRenderFns } from "./BudgetMaster.vue?vue&type=template&id=5a3273b3&scoped=true"
import script from "./BudgetMaster.vue?vue&type=script&lang=js"
export * from "./BudgetMaster.vue?vue&type=script&lang=js"
import style0 from "./BudgetMaster.vue?vue&type=style&index=0&id=5a3273b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3273b3",
  null
  
)

export default component.exports